import { render, staticRenderFns } from "./assetChanges.vue?vue&type=template&id=0980eaf1&"
import script from "./assetChanges.vue?vue&type=script&lang=js&"
export * from "./assetChanges.vue?vue&type=script&lang=js&"
import style0 from "./assetChanges.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports